import { axios } from 'services/axios';
import { PlatformEnums } from 'utils/platforms';
import { normaliseCatalogue } from 'utils/eightByEightCatalog';

/**
 * Returns 8x8 licence/catalogue items.
 *
 * New object signature (service profile form):
 *   getEightByEightCatalogue({ level, partnerID, companyID })
 *   - Wholesaler: GET /CatalogItems/{platformID}  (static PlatformEnums.EIGHTBYEIGHT)
 *   - Partner:    GET /ServiceProfiles/EightByEight/Partner/{partnerID}/Licenses/Available
 *   - Company:    GET /Services/EightByEight/Company/{companyID}/Licenses/Available
 *
 * Legacy string signature (company services):
 *   getEightByEightCatalogue(serviceId?, scope?)
 *   - GET /CatalogItems/{serviceId}
 *
 * @param {string|{level:string,partnerID?:string,companyID?:string}} [firstArg]
 * @param {number} [scope]
 */
const getEightByEightCatalogue = async (firstArg, scope) => {
    if (firstArg !== null && typeof firstArg === 'object') {
        const { level, partnerID, companyID } = firstArg;
        if (level === 'partner') {
            const res = await axios.get(
                `/ServiceProfiles/EightByEight/Partner/${partnerID}/Licenses/Available`,
                {
                    _requestScopeOverride: 60,
                },
            );
            return { data: normaliseCatalogue(res.data) };
        }
        if (level === 'company') {
            // Manage Licences: the licences available to the company, inherited
            // from the associated partner service profile — NOT the full
            // platform catalogue. Matches the /Services/{Type}/Company/{id}/...
            // /Available convention used by other services (SBCaaS, ACS).
            const res = await axios.get(
                `/Services/EightByEight/Company/${companyID}/Licenses/Available`,
            );
            return { data: normaliseCatalogue(res.data) };
        }
        // Wholesaler: platform ID is statically known
        const res = await axios.get(
            `/CatalogItems/${PlatformEnums.EIGHTBYEIGHT}`,
            {
                headers: { 'X-RequestScope': (scope = 80) },
            },
        );
        return { data: normaliseCatalogue(res.data) };
    }

    // Legacy: getEightByEightCatalogue(serviceId?, scope?)
    try {
        if (!firstArg) return { data: [] };
        const response = await axios.get(`/CatalogItems/${firstArg}`, {
            headers: { 'X-RequestScope': scope },
        });
        return { data: normaliseCatalogue(response.data) };
    } catch {
        return { data: [] };
    }
};

export default getEightByEightCatalogue;
